import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input, Col } from 'reactstrap';
import { Formik, Form, FieldArray } from "formik";
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import * as XLSX from "xlsx";
import '../../SupportSystem/Reports/reportall.css';
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";

export function NewReportAllocatedAndSubsidies39Component() {
    const [data, setData] = useState([]);
    const [selectSupport, setSelectSupport] = useState([]);
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const [openModal, setOpenModal] = useState(false);
    const ToggleModal = () => setOpenModal(!openModal);

    useEffect(() => { getdatafromview(); }, []);

    async function getdatafromview() {
        setLoading(true);
        try {
            let res = await fetch("/api/SupportAllowcate/listAllocated39", {
                method: "POST",
                headers: { 'token': user.token },
            });
            const d = await res.json();
            setData(d.dataenum || []);
            setSelectSupport(
                (d.dataenum || []).filter((v, i, arr) => arr.findIndex(v2 => v2.supportId === v.supportId) === i)
            );
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    // --- group by supportId เพื่อทำ rowSpan เฉพาะคอลัมน์ที่ต้องการ merge ---
    const groupBySupport = (rows) => {
        const map = new Map();
        const order = [];
        rows?.forEach(r => {
            const k = r.supportId;
            if (!map.has(k)) { map.set(k, []); order.push(k); }
            map.get(k).push(r);
        });
        return order.map((k, idx) => ({
            supportId: k,
            seq: idx + 1,
            rows: map.get(k),
            rowspan: map.get(k).length
        }));
    };
    const groups = groupBySupport(data);

    // --- Export XLSX: merge หัวตาราง + merge คอลัมน์ [เลขที่คำขอ, วันที่รับคำขอ, ชื่อผู้ขอ, จำนวนเงินที่ขอรับ, จำนวนเงินที่อนุมัติ] ---
    const exportXlsxMerged39 = (rows) => {
        const groupsSelected = groupBySupport(rows);

        // คอลัมน์ทั้งหมด 21 คอลัมน์ (0..20)
        const COL = {
            SEQ: 0,
            SUPPORT_NO: 1,
            CREATE_DATE: 2,
            SUPPORT_NAME: 3,
            INNO_NAME: 4,
            INNO_COURSE: 5,
            APPROVE_DATE: 6,
            HOURS: 7,
            CLASS_AMOUNT: 8,
            START_DATE: 9,
            END_DATE: 10,
            PERSON_TOTAL: 11,
            SELF_TUTOR: 12,
            SELF_MATERIAL: 13,
            SELF_REGISTER: 14,
            SEND_TUTOR: 15,
            SEND_MATERIAL: 16,
            SEND_REGISTER: 17,
            TOTAL_AMOUNT: 18,
            REQ_AMOUNT: 19,
            APPROVED_AMOUNT: 20,
        };

        // หัวตาราง 3 แถวให้ตรงกับ thead
        const h0 = [
            "ที่", "เลขที่คำขอ", "วันที่รับคำขอ", "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
            "ชื่อหลักสูตรสร้างสรรค์นวัตกรรม", "ชื่อหลักสูตรเทคโนโลยี", "หลักสูตรได้รับความเห็นชอบ (ว/ด/ป)",
            "ระยะเวลาฝึกอบรม (ชม.)", "จำนวน (รุ่น)", "วันที่เริ่มฝึก", "วันที่จบฝึก", "จำนวนลูกจ้างที่เข้ารับการฝึกอบรม (คน)",
            "ค่าใช้จ่ายในการฝึกอบรม", "", "", "", "", "",
            "รวมจำนวน (บาท)", "จำนวนเงินที่ขอรับ (บาท)", "จำนวนเงินที่อนุมัติ (บาท)"
        ];
        const h1 = [
            "", "", "", "", "", "", "", "", "", "", "", "",
            "ฝึกอบรมเอง", "", "",
            "ส่งไปฝึก", "", "",
            "", "", ""
        ];
        const h2 = [
            "", "", "", "", "", "", "", "", "", "", "", "",
            "ค่าวิทยากร (บาท)", "ค่าวัสดุ (บาท)", "ค่าลงทะเบียน (บาท)",
            "ค่าวิทยากร (บาท)", "ค่าวัสดุ (บาท)", "ค่าลงทะเบียน (บาท)",
            "", "", ""
        ];

        const aoa = [h0, h1, h2];

        const numOrEmpty = v => (v === null || v === undefined || v === "" ? "" : Number(v));
        const strOrDash = v => (v === null || v === undefined || v === "" ? "-" : v);

        // เติมข้อมูล: คอลัมน์ที่ "merge" ให้ใส่เฉพาะแถวแรกของกลุ่ม ที่เหลือเว้นว่าง
        groupsSelected.forEach(g => {
            g.rows.forEach((r, idx) => {
                aoa.push([
                    idx === 0 ? g.seq : "",                          // 0 ที่ (merge)
                    idx === 0 ? strOrDash(r.supportNo) : "",         // 1 เลขที่คำขอ (merge)
                    idx === 0 ? strOrDash(r.createDate) : "",        // 2 วันที่รับคำขอ (merge)
                    idx === 0 ? strOrDash(r.supportName) : "",       // 3 ชื่อผู้ขอ (merge)

                    strOrDash(r.innovationName),                     // 4
                    strOrDash(r.innovationCourseName),               // 5
                    strOrDash(r.updateDate),                         // 6
                    numOrEmpty(r.hour),                              // 7
                    numOrEmpty(r.classAmount),                       // 8
                    strOrDash(r.startDate),                          // 9
                    strOrDash(r.endDate),                            // 10
                    numOrEmpty(r.personTotal),                       // 11

                    numOrEmpty(r.tutorHourAmount),                   // 12 ฝึกอบรมเอง - วิทยากร
                    numOrEmpty(r.materialAmount),                    // 13 ฝึกอบรมเอง - วัสดุ
                    numOrEmpty(r.personAmount),                      // 14 ฝึกอบรมเอง - ลงทะเบียน

                    numOrEmpty(r.sendTutorAmount),                   // 15 ส่งไปฝึก - วิทยากร
                    numOrEmpty(r.sendMaterialAmount),                // 16 ส่งไปฝึก - วัสดุ
                    numOrEmpty(r.sendRegisterAmount),                // 17 ส่งไปฝึก - ลงทะเบียน

                    numOrEmpty(r.amount),                            // 18 รวมจำนวน(บาท) (ไม่ merge)
                    idx === 0 ? numOrEmpty(r.paymentAmount) : "",    // 19 จำนวนเงินที่ขอรับ (merge)
                    idx === 0 ? numOrEmpty(r.paymentAmount) : ""     // 20 จำนวนเงินที่อนุมัติ (merge) *ถ้ามี field แยกให้เปลี่ยนได้
                ]);
            });
        });

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        // ความกว้างคอลัมน์พออ่านง่าย
        ws["!cols"] = [
            { wch: 6 }, { wch: 16 }, { wch: 16 }, { wch: 36 },
            { wch: 28 }, { wch: 28 }, { wch: 18 },
            { wch: 16 }, { wch: 12 }, { wch: 16 }, { wch: 16 }, { wch: 22 },
            { wch: 16 }, { wch: 16 }, { wch: 16 },
            { wch: 16 }, { wch: 16 }, { wch: 16 },
            { wch: 18 }, { wch: 20 }, { wch: 20 }
        ];

        // Merge หัวตาราง
        const merges = [];
        // แถว 0: col 0..11 rowSpan=3
        for (let c = 0; c <= 11; c++) merges.push({ s: { r: 0, c }, e: { r: 2, c } });
        // "ค่าใช้จ่ายในการฝึกอบรม" ครอบ 12..17 ที่แถว 0
        merges.push({ s: { r: 0, c: 12 }, e: { r: 0, c: 17 } });
        // แถว 1: "ฝึกอบรมเอง" ครอบ 12..14, "ส่งไปฝึก" ครอบ 15..17
        merges.push({ s: { r: 1, c: 12 }, e: { r: 1, c: 14 } });
        merges.push({ s: { r: 1, c: 15 }, e: { r: 1, c: 17 } });
        // แถว 0: col 18..20 rowSpan=3
        for (let c = 18; c <= 20; c++) merges.push({ s: { r: 0, c }, e: { r: 2, c } });

        // Merge บอดี้: ที่ + 5 คอลัมน์ตามที่ร้องขอ
        const headerRows = 3;
        let cur = headerRows;
        groupsSelected.forEach(g => {
            const start = cur;
            const end = cur + g.rowspan - 1;
            if (g.rowspan > 1) {
                [COL.SEQ, COL.SUPPORT_NO, COL.CREATE_DATE, COL.SUPPORT_NAME, COL.REQ_AMOUNT, COL.APPROVED_AMOUNT]
                    .forEach(c => merges.push({ s: { r: start, c }, e: { r: end, c } }));
            }
            cur = end + 1;
        });

        ws["!merges"] = merges;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "รายงานข้อ6-นวัตกรรม");
        XLSX.writeFile(wb, "แบบขอรับการจัดสรร_ประกาศข้อ6_นวัตกรรม.xlsx");
    };

    const ExportSupport = async (values) => {
        setLoading(true);
        try {
            const picked = (values?.selectExportAr || []).filter(v => v.status);

            const selectedIds = (values?.selectExportAr || [])
                .filter(x => x.status)
                .map(x => x.supportId);

            if (!selectedIds.length) {
                await Swal.fire({
                    icon: "error",
                    title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
                return;
            }

            const rows = data.filter(d => selectedIds.includes(d.supportId));
            exportXlsxMerged39(rows);
            // 7) อัปเดตสถานะหลังบ้าน (ส่ง supportId[])
            let formData = new FormData();
            let supportIdAr = Array.from(new Set(picked.map(p => p.supportId))).filter(Boolean);
            // console.log(supportIdAr)
            supportIdAr.forEach(item => formData.append("supportIds", item))
            const updateRes = await fetch("/api/SupportAllowCate/updateStatusSupportAllocate", {
                method: "POST",
                body: formData

            });
            if (!updateRes.ok) throw new Error("อัปเดตสถานะไม่สำเร็จ");

            await Swal.fire({
                icon: "success",
                title: "ส่งออกสำเร็จ",
                text: "ได้ทำการอัปเดตสถานะเรียบร้อยแล้ว",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });
        } catch (e) {
            console.log(e);
            Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการส่งออกไฟล์" });
        } finally {
            setLoading(false);
        }
    };

    const initialValues = {
        selectExportAr: selectSupport.map(item => ({
            supportId: item?.supportId,
            status: false,
        })),
    };
    const validateSchema = Yup.object().shape({});

    if (loading) return <Loading />;

    return (
        <Container>
            <center>
                <Label>
                    แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ.
                    {data?.length ? data[0]?.budgetYear : null}
                </Label>
            </center>
            <center><Label>ตามประกาศคณะกรรมการส่งเสริมการพัฒนาฝีมือแรงงาน</Label></center>
            <center>
                <Label>เรื่อง หลักเกณฑ์การใช้จ่ายเงินเพื่อช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ลงวันที่ 31 มีนาคม พ.ศ. 2568</Label>
            </center>

            <div className="d-flex w-100 align-items-center justify-content-end mb-3">
                <button
                    onClick={ToggleModal}
                    disabled={!selectSupport.length}
                    className="btn-green p-2 w-25"
                >
                    Export Excel
                </button>
            </div>

            <div className="outer-wrapper">
                <div className="table-wrapper">
                    <table>
                        <thead className="">
                            <tr>
                                <th rowSpan={3} className="text-center align-middle">ที่</th>
                                <th rowSpan={3} className="text-center align-middle">เลขที่คำขอ</th>
                                <th rowSpan={3} className="text-center align-middle">วันที่รับคำขอ</th>
                                <th rowSpan={3} className="text-center align-middle">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</th>
                                <th rowSpan={3} className="text-center align-middle">ชื่อหลักสูตรสร้างสรรค์นวัตกรรม</th>
                                <th rowSpan={3} className="text-center align-middle">ชื่อหลักสูตรเทคโนโลยี</th>
                                <th rowSpan={3} className="text-center align-middle">หลักสูตรได้รับความเห็นชอบ<br />(ว/ด/ป)</th>
                                <th rowSpan={3} className="text-center align-middle">ระยะเวลาฝึกอบรม<br />(ชม.)</th>
                                <th rowSpan={3} className="text-center align-middle">จำนวน<br />(รุ่น)</th>
                                <th rowSpan={3} className="text-center align-middle">วันที่เริ่มฝึก</th>
                                <th rowSpan={3} className="text-center align-middle">วันที่จบฝึก</th>
                                <th rowSpan={3} className="text-center align-middle">จำนวนลูกจ้างที่เข้ารับการฝึกอบรม<br />(คน)</th>
                                <th colSpan={6} className="text-center align-middle">ค่าใช้จ่ายในการฝึกอบรม</th>
                                <th rowSpan={3} className="text-center align-middle">รวมจำนวน<br />(บาท)</th>
                                <th rowSpan={3} className="text-center align-middle">จำนวนเงินที่ขอรับ<br />(บาท)</th>
                                <th rowSpan={3} className="text-center align-middle">จำนวนเงินที่อนุมัติ<br />(บาท)</th>
                            </tr>
                            <tr>
                                <th colSpan={3} className="text-center align-middle">ฝึกอบรมเอง</th>
                                <th colSpan={3} className="text-center align-middle">ส่งไปฝึก</th>
                            </tr>
                            <tr>
                                <th className="text-center">ค่าวิทยากร<br />(บาท)</th>
                                <th className="text-center">ค่าวัสดุ<br />(บาท)</th>
                                <th className="text-center">ค่าลงทะเบียน<br />(บาท)</th>
                                <th className="text-center">ค่าวิทยากร<br />(บาท)</th>
                                <th className="text-center">ค่าวัสดุ<br />(บาท)</th>
                                <th className="text-center">ค่าลงทะเบียน<br />(บาท)</th>
                            </tr>
                        </thead>

                        <tbody>
                            {groups?.length ? (
                                groups.map(g =>
                                    g.rows.map((item, idx) => (
                                        <tr key={`${g.supportId}-${idx}`}>
                                            {/* ที่ (merge) */}
                                            {idx === 0 && <td rowSpan={g.rowspan} className="text-center">{g.seq}</td>}

                                            {/* เลขที่คำขอ (merge) */}
                                            {idx === 0
                                                ? <td rowSpan={g.rowspan} className="text-center">{item.supportNo ?? "-"}</td>
                                                : null}

                                            {/* วันที่รับคำขอ (merge) */}
                                            {idx === 0
                                                ? <td rowSpan={g.rowspan} className="text-center">{item.createDate ?? "-"}</td>
                                                : null}

                                            {/* ชื่อผู้ขอรับเงินช่วยเหลือฯ (merge) */}
                                            {idx === 0
                                                ? <td rowSpan={g.rowspan} className="text-center">{item.supportName ?? "-"}</td>
                                                : null}

                                            {/* คอลัมน์อื่น ๆ แสดงทุกแถว */}
                                            <td className="text-center">{item.innovationName ?? "-"}</td>
                                            <td className="text-center">{item.innovationCourseName ?? "-"}</td>
                                            <td className="text-center">{item.updateDate ?? "-"}</td>
                                            <td className="text-center">{item.hour ?? "-"}</td>
                                            <td className="text-center">{item.classAmount ?? "-"}</td>
                                            <td className="text-center">{item.startDate ?? "-"}</td>
                                            <td className="text-center">{item.endDate ?? "-"}</td>
                                            <td className="text-center">{item.personTotal ?? "-"}</td>

                                            <td className="text-center">{item.tutorHourAmount ?? "-"}</td>
                                            <td className="text-center">{item.materialAmount ?? "-"}</td>
                                            <td className="text-center">{item.personAmount ?? "-"}</td>
                                            <td className="text-center">{item.sendTutorAmount ?? "-"}</td>
                                            <td className="text-center">{item.sendMaterialAmount ?? "-"}</td>
                                            <td className="text-center">{item.sendRegisterAmount ?? "-"}</td>

                                            <td className="text-end">{item.amount != null ? NumberWithCommmas2(item.amount) : "-"}</td>

                                            {/* จำนวนเงินที่ขอรับ (merge) */}
                                            {idx === 0
                                                ? <td rowSpan={g.rowspan} className="text-end">
                                                    {item.paymentAmount != null ? item.paymentAmount : "-"}
                                                </td>
                                                : null}

                                            {/* จำนวนเงินที่อนุมัติ (merge) */}
                                            {idx === 0
                                                ? <td rowSpan={g.rowspan} className="text-end">
                                                    {item.paymentAmount != null ? item.paymentAmount : "-"}
                                                </td>
                                                : null}
                                        </tr>
                                    ))
                                )
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan={21}>ไม่มีข้อมูล</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal เลือกผู้ขอรับเงิน */}
            <Modal
                isOpen={openModal}
                toggle={ToggleModal}
                backdrop={'static'}
                keyboard={false}
                size="l"
                className="modal-bordered"
                centered
            >
                <Formik
                    enableReinitialize
                    initialValues={{
                        selectExportAr: selectSupport.map(item => ({ supportId: item?.supportId, status: false })),
                    }}
                    validationSchema={validateSchema}
                    onSubmit={ExportSupport}
                >
                    {({ values, handleChange, handleBlur, setFieldValue, handleSubmit }) => {

                        const PreExport = () => {
                            const pass = values.selectExportAr.some(el => el.status === true);
                            if (!pass) {
                                Swal.fire({
                                    icon: "error",
                                    title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                });
                            } else {
                                Swal.fire({
                                    icon: "info",
                                    title: "ยืนยันการทำรายการหรือไม่ ?",
                                    html: "หากยืนยันการทำรายการแล้ว <br/>จะไม่สามารถเลือกผู้ขอรับเงินช่วยเหลือหรืออุดหนุนเดิมได้",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                    showCancelButton: true,
                                    cancelButtonText: "ยกเลิก",
                                    cancelButtonColor: "#ff0000",
                                }).then((result) => {
                                    if (result.isConfirmed) handleSubmit(values);
                                });
                            }
                        };

                        return (
                            <Form>
                                <ModalHeader toggle={ToggleModal}>เลือกชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</ModalHeader>
                                <ModalBody>
                                    <FieldArray name="selectExportAr">
                                        {() => (
                                            <div className="d-flex flex-column mt-3">
                                                {selectSupport?.map((support, index) => (
                                                    <FormGroup row key={support.supportId ?? index}>
                                                        <Col>
                                                            <Label>
                                                                <Input
                                                                    type="checkbox"
                                                                    className="cus-type"
                                                                    name={`selectExportAr[${index}].status`}
                                                                    onBlur={handleBlur}
                                                                    onChange={(e) => {
                                                                        handleChange(e);
                                                                        setFieldValue(e.target.name, e.target.checked);
                                                                    }}
                                                                />
                                                            </Label>
                                                            <span className="ms-3">{support.supportName}</span>
                                                        </Col>
                                                    </FormGroup>
                                                ))}
                                            </div>
                                        )}
                                    </FieldArray>
                                </ModalBody>
                                <ModalFooter className="d-flex justify-content-center align-items-center">
                                    <button
                                        disabled={!selectSupport.length}
                                        type="button"
                                        onClick={PreExport}
                                        className="btn-green p-2 w-25"
                                    >
                                        Export
                                    </button>
                                </ModalFooter>
                            </Form>
                        );
                    }}
                </Formik>
            </Modal>
        </Container>
    );
}

const validateSchema = Yup.object().shape({});
